import React, { useEffect, useRef, useCallback } from 'react'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { ButtonWrapper } from '../../style/StyledElement'
import DownloadIcon from '@mui/icons-material/Download'
import Button from '@mui/material/Button'
import SkeletonTable from './Skeleton'
import {
  AgGridNoDataWrapper,
  GridWrapper,
  NoData,
  RedText,
  LoadingWrapper,
  GirdDiv,
} from '../../style/StyledElement'

const AgGridWrapper = ({
  error,
  loading,
  submitted,
  api,
  headers,
  data,
  downloadStatus,
  setDownloadStatus,
}) => {
  const gridRef = useRef()

  useEffect(() => {
    if (downloadStatus && gridRef.current && gridRef.current.api) {
      gridRef.current.api.exportDataAsCsv({
        fileName: 'admet_analysis_results.csv'
      })
      if (typeof setDownloadStatus === 'function') {
        setDownloadStatus(false)
      }
    }
  }, [downloadStatus, setDownloadStatus])

  const onSelection = (params) => {
    if (api) {
      const { data } = params
      data && api(data)
    } else {
      console.log('api not provided')
    }
  }

  const onBtnExport = useCallback(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.exportDataAsCsv({
        fileName: 'table_export.csv'
      })
    }
  }, [])

  return (
    <GirdDiv>
      {loading && (
        <LoadingWrapper>
          <SkeletonTable />
        </LoadingWrapper>
      )}
      {error && (
        <AgGridNoDataWrapper>
          <RedText>Failed to retrieve data</RedText>
        </AgGridNoDataWrapper>
      )}
      {!loading && !error && !data && (
        <AgGridNoDataWrapper></AgGridNoDataWrapper>
      )}
      {!loading && !error && !submitted && data && (data.length === 0 || data === 'NO_RESULTS') && (
        <AgGridNoDataWrapper>
          <NoData>No Data Found</NoData>
        </AgGridNoDataWrapper>
      )}
      {submitted && (
        <AgGridNoDataWrapper>
          <NoData>Job has been submitted Successfully</NoData>
        </AgGridNoDataWrapper>
      )}
      {!loading && data && data.length > 0 && (
        <GridWrapper className="ag-theme-alpine">
          <ButtonWrapper>
            <Button
              variant="contained"
              size="small"
              startIcon={<DownloadIcon />}
              onClick={onBtnExport}
              sx={{
                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                color: '#FFFFFF',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 2px 8px rgba(16, 185, 129, 0.25)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                }
              }}
            >
              Export CSV
            </Button>
          </ButtonWrapper>
          <AgGridReact
            ref={gridRef}
            columnDefs={headers}
            rowData={data}
            defaultColDef={{
              resizable: true,
              editable: false,
              sortable: true,
              flex: 1,
              minWidth: 100,
            }}
            rowStyle={{ cursor: 'pointer' }}
            containerStyle={{ height: '90%', width: '100%' }}
            onRowClicked={onSelection}
            rowSelection="single"
            pagination={true}
            reactiveCustomComponents={true}
          />
        </GridWrapper>
      )}
    </GirdDiv>
  )
}

export default AgGridWrapper
